import 'Styles/common.less';

import 'Components/card/card.less';
import 'Components/info-number/info-number.less';
import 'Components/icon-list/icon-list.less';
import 'Components/section-header/section-header.less';
import 'Components/figure-list/figure-list.less';
import 'Components/list/list.less';
import 'WebComponents/tabs/tabs.less';

import './links/links.less';
import './directions/directions.less';
import './calculator/calculator.less';
import './timing/timing.less';
import './stuff/stuff.less';
import './advantages/advantages.less';
import './license/license.less';

import 'WebComponents/greedy-nav';
import './slider';
import { A11y } from 'WebComponents/a11y';

const a11y = new A11y();

import { CalculatorExams } from 'WebComponents/calculator';
const calculatorExams = new CalculatorExams();

import Promise from 'babel-runtime/core-js/promise'; 
if (!window.Promise) {
  window.Promise = Promise;
}

const componentContext = [
  require('bundle-loader?name=tabs!WebComponents/tabs'),
];
document.addEventListener('DOMContentLoaded', () => {
  componentContext.forEach((context) => {
    context(() => {});
  });
  a11y.init();
  calculatorExams.init();
});

const iconsContext = require('bundle-loader?lazy&name=admission-icons!./icons');
// TODO: replace event from onload to onscroll to container
window.addEventListener('load', () => {
  iconsContext(() => {});
});



// WEBPACK FOOTER //
// ./src/pages/admission/index.js